import React from "react";
import message from "../../assets/Message.svg";

function PaymentNotification() {
  return (
    <div className="flex items-center justify-center h-screen bg-[#ababab] ">
      <div className="flex flex-col gap-[25px] md:gap-[52px] max-w-max mx-auto bg-white rounded-lg py-[88px] px-[32px] md:pt-[99px] md:pb-[88px] md:px-[64px] ">
        <div className="w-[45px] md:w-[91px] md:h-[91px] h-[45px] rounded-full bg-[#F2EEEE] font-bold flex items-center justify-center md:text-5xl text-base">
          ?
        </div>
        <p className="md:text-2xl text-base">
          Are you sure you’ve confirmed your payments?{" "}
        </p>
        <div className="flex items-center gap-4 text-xs md:text-base">
          <button className="w-[127px] md:w-[256px] md:h-[60px] h-[30px] bg-[#FBC108] text-white rounded-sm ">
            Yes, I have
          </button>
          <button className="w-[127px] md:w-[256px] md:h-[60px] h-[30px] border-[1px] border-[#FBC108]  rounded-sm ">
            No, I haven’t
          </button>
        </div>
        <div className="hidden md:flex items-center gap-4">
          <img src={message} alt="" />
          <p className="text-[#ababab] ">Message</p>
        </div>
      </div>
    </div>
  );
}

export default PaymentNotification;
